import { debounce, rem2px, px2rem } from "@js/utils";
/**
 * @description 自适应屏幕内容
 * @param {Number} vertical 垂直方向上需减去的边距 单位rem 默认 0
 * @param {Number} horizontal 水平方向需减去的边距 单位rem 默认 0
 * @param {String} targetSelect 被适应对象选择器 默认 .fit
 * @param {HTMLElement} parent 被适应对象的父容器 默认doucment
 * @param {String} accord 只按照width或者height来自适应 默认全部
 */
var fitContent = async function (
  vertical = 0,
  horizontal = 0,
  targetSelect = ".fit",
  parent = document.querySelector("#main"),
  accord = "both"
) {
  parent = parent ? parent : document.querySelector("#main");
  if (
    rem2px(vertical) > parent.offsetHeight ||
    rem2px(horizontal) > parent.offsetWidth
  ) {
    console.error("非正常页面");
    return;
  }

  Array.from(document.querySelectorAll(targetSelect)).forEach(function (i) {
    console.log(
      i,
      i.offsetWidth,
      i.offsetHeight,
      i.getAttribute("data-origin-h")
    );
    var cw = parent.offsetWidth - rem2px(horizontal),
      ch = parent.offsetHeight - rem2px(vertical);
    var beforeW =
      i.getAttribute("data-origin-w") || i.offsetWidth != 0
        ? rem2px(i.getAttribute("data-origin-w") - 0) || i.offsetWidth
        : cw;
    var beforeH =
      i.getAttribute("data-origin-h") || i.offsetHeight != 0
        ? rem2px(i.getAttribute("data-origin-h") - 0) || i.offsetHeight
        : ch;

    i.setAttribute("data-origin-w", px2rem(beforeW));
    i.setAttribute("data-origin-h", px2rem(beforeH));
    var tw = beforeW,
      th = beforeH;

    console.log(cw, ch, tw, th);

    var scale = Math.ceil(Math.min(cw / tw, ch / th) * 100) / 100;

    let sw = tw / scale,
      sh = th / scale;
    if ((accord == "width" || accord == "both") && cw / tw < ch / th) {
      sh = sh < ch ? ch : sh;
      i.style.width = sw + "px";
      i.style.height = sh + "px";
      console.log(11111, i);
    } else if ((accord == "height" || accord == "both") && cw / tw > ch / th) {
      sw = sw < cw ? cw : sw;
      i.style.width = sw + "px";
      i.style.height = sh + "px";
      console.log(22222, i);
    } else {
      sw = sw < cw ? cw : sw;
      sh = sh < ch ? ch : sh;
      i.style.width = sw + "px";
      i.style.height = sh + "px";
      console.log(33333, i);
    }
    i.style.marginLeft = cw * 0.5 + "px";
    i.style.transformOrigin = "center";
    i.style.transform = setScale(i, scale);
  });
  function setScale(i, scale) {
    if (i.style.transform.indexOf("matrix") >= 0) {
      // 如果使用了matrix
      let t = i.style.transform.replace(/(matrix\(|\))/g, "").split(",");
      t[0] = scale;
      t[3] = scale;
      t[4] = i.offsetWidth * -0.5;
      return "matrix(" + t.join(",") + ")";
    } else {
      // 未使用matrix
      return `matrix(${scale}, 0, 0, ${scale}, ${i.offsetWidth * -0.5}, 0)`;
    }
  }
  return Promise.resolve();
};

export default fitContent;
